import { getCookie } from 'cookies-next/client'
import type { IRedux } from '../_store/types'

export type MiniAppProvider = 'click' | 'my_uzbekistan'

export interface MiniAppCrmData {
  description?: string
  offer?: string
  source_id?: string
  public_offer?: string
}

export const MINI_APP_CAPABILITIES: Record<
  MiniAppProvider,
  { supportsPublicOffer: boolean; supportsFlutterHandler: boolean }
> = {
  click: {
    supportsPublicOffer: false,
    supportsFlutterHandler: false,
  },
  my_uzbekistan: {
    supportsPublicOffer: true,
    supportsFlutterHandler: true,
  },
}

export const getMiniAppProvider = (domain: string | null): MiniAppProvider => {
  const host =
    domain ||
    (typeof window !== 'undefined' ? window.location.hostname : undefined) ||
    ''
  const normalizedHost = host.toLowerCase().split(':')[0]
  const subdomain = normalizedHost.split('.')[0]

  if (subdomain === 'myuzbekistan') return 'my_uzbekistan'

  return 'click'
}

export const getMiniAppCrmType = (provider: MiniAppProvider) =>
  provider === 'my_uzbekistan' ? 'my-uzbekistan' : 'click-mini-app'

export const supportsFlutterHandler = (provider: MiniAppProvider) =>
  MINI_APP_CAPABILITIES[provider].supportsFlutterHandler

export const getEffectiveSourceId = (
  state?: Pick<IRedux, 'session' | 'auth'>
): string => {
  const sourceId =
    state?.session?.source_id ??
    state?.auth?.miniAppCrmData?.source_id ??
    getCookie('source_id')

  return sourceId ? String(sourceId) : ''
}
